import { AxiosPromise, CancelToken } from 'axios';
import { UpdatePasswordInputs } from '../sic-lib/types/Password';
import { apiInstance as instance } from './';

/**
 * Make HTTP request to update current user's password
 * @param data
 * @param cancelToken
 */
export function requestPasswordUpdate(
    data: UpdatePasswordInputs,
    cancelToken: CancelToken,
): AxiosPromise<boolean> {
    return instance.put('/users/password', data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
